// extracted by mini-css-extract-plugin
export default {"CompanyInfoContainer":"CompanyInfo_CompanyInfoContainer__BnMwZ","CompanyText":"CompanyInfo_CompanyText__ZKtiC","CompanyLogoContainer":"CompanyInfo_CompanyLogoContainer__RFXXH"};